export const PRICING_MARKUP_MIN = 0.2;
export const PRICING_MARKUP_MAX = 4.05;
export const PRICING_MARKUP_SCALE = 434_294;

export function markupForUsage(usage: number): number {
  const safeUsage = Number.isFinite(usage) && usage > 0 ? usage : 0;
  return (
    PRICING_MARKUP_MIN +
    (PRICING_MARKUP_MAX - PRICING_MARKUP_MIN) *
      Math.exp(-safeUsage / PRICING_MARKUP_SCALE)
  );
}

export function relativePriceMultiplier(usage: number): number {
  return 1 + markupForUsage(usage);
}
